/**
 * RBAC Cache Management Styles
 * Carbon Design System compliant styling
 */
.rbacCacheManagement {
  padding: var(--cds-spacing-05);
  background: var(--cds-background);
  min-height: 100vh;
}

.header {
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  margin-bottom: var(--cds-spacing-06);
  padding-bottom: var(--cds-spacing-05);
  border-bottom: 1px solid var(--cds-border-subtle);
}
.header h2 {
  margin-bottom: var(--cds-spacing-02);
}

.description {
  color: var(--cds-text-secondary);
  font-size: var(--cds-body-01-font-size);
  margin-top: var(--cds-spacing-02);
}

.actions {
  display: flex;
  gap: var(--cds-spacing-03);
}

.metricsSection {
  margin-bottom: var(--cds-spacing-07);
}
.metricsSection h3 {
  margin-bottom: var(--cds-spacing-05);
}

.metricsGrid {
  margin-top: var(--cds-spacing-05);
}

.metricTile {
  height: 100%;
  padding: var(--cds-spacing-05);
  background: var(--cds-layer-01);
  transition: background 0.2s ease;
}
.metricTile:hover {
  background: var(--cds-layer-hover);
}

.metricHeader {
  display: flex;
  align-items: center;
  gap: var(--cds-spacing-03);
  margin-bottom: var(--cds-spacing-04);
}
.metricHeader h4 {
  font-size: var(--cds-heading-03-font-size);
  font-weight: var(--cds-heading-03-font-weight);
  color: var(--cds-text-primary);
  margin: 0;
}

.metricIcon {
  color: var(--cds-icon-primary);
}

.metricValue {
  display: flex;
  align-items: center;
  gap: var(--cds-spacing-03);
  margin-bottom: var(--cds-spacing-03);
}
.metricValue .value {
  font-size: var(--cds-display-01-font-size);
  font-weight: var(--cds-display-01-font-weight);
  color: var(--cds-text-primary);
}
.metricValue .successIcon {
  color: var(--cds-support-success);
}
.metricValue .warningIcon {
  color: var(--cds-support-warning);
}
.metricValue .errorIcon {
  color: var(--cds-support-error);
}

.metricSubtitle {
  font-size: var(--cds-label-01-font-size);
  color: var(--cds-text-secondary);
  margin: 0;
}

.chartSection {
  margin-bottom: var(--cds-spacing-07);
  padding: var(--cds-spacing-05);
  background: var(--cds-layer-01);
  border-radius: 4px;
}
.chartSection h3 {
  margin-bottom: var(--cds-spacing-05);
}

.chartContainer {
  width: 100%;
  height: 300px;
  margin-top: var(--cds-spacing-05);
}

.tableSection {
  margin-bottom: var(--cds-spacing-07);
}
.tableSection h3 {
  margin-bottom: var(--cds-spacing-05);
}

.modalContent {
  display: flex;
  flex-direction: column;
  gap: var(--cds-spacing-05);
  padding: var(--cds-spacing-05) 0;
}
.modalContent > * {
  width: 100%;
}

/* Responsive Design */
@media (max-width: 672px) {
  .header {
    flex-direction: column;
    gap: var(--cds-spacing-05);
  }
  .actions {
    flex-direction: column;
    width: 100%;
  }
  .actions button {
    width: 100%;
  }
  .metricTile {
    min-height: 140px;
  }
  .chartContainer {
    height: 250px;
  }
}
/* Dark Mode Support */
@media (prefers-color-scheme: dark) {
  .rbacCacheManagement {
    background: var(--cds-background);
  }
  .chartSection {
    background: var(--cds-layer-02);
  }
  .metricTile {
    background: var(--cds-layer-01);
  }
  .metricTile:hover {
    background: var(--cds-layer-hover);
  }
}
/* Accessibility */
@media (prefers-reduced-motion: reduce) {
  .metricTile {
    transition: none;
  }
}
/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */